<template>
  <div class="notice-setting-vue">
    <div class="subframe-title">修改手机</div>
    <Form v-width="360" mode="block" :model="model" :rules="validationRules" ref="form">
      <FormItem label="手机号" prop="mobile">
        <input type="text" v-model="model.mobile"/>
      </FormItem>
      <FormItem label="验证码" prop="verificationCode" v-if="model.mobile && model.mobile !== account.mobile">
        <CaptchaVerificationCode ref="captcha" v-model="model.verificationCode" :mobile="model.mobile" @enter="save"/>
      </FormItem>
      <FormItem>
        <Button @click="save" color="primary" :loading="isLoading">保存</Button>
      </FormItem>
    </Form>
  </div>
</template>
<script>
  import CaptchaVerificationCode from "../../components/CaptchaVerificationCode";
  import {mapGetters} from "vuex";


  export default {
    name: "ChangePhoneNumber",
    components: {CaptchaVerificationCode},
    data() {
      return {
	      isLoading:false,
        model: {
          verificationCode: null,
          mobile: null,
        },
        validationRules: {
          required: ['verificationCode', 'mobile'],
          mobile: ['mobile']
        }
      };
    },
    mounted() {
      this.model.mobile = this.account.mobile;
    },
    methods: {
	    save() {
		    let validResult = this.$refs.form.valid();
		    if (validResult.result) {
			    this.isLoading = true;
			    this.$api.common.changePhoneNumber(this.model).then(() => {
				    this.$Message('更新手机号成功');
				    this.isLoading = false;
				    this.$store.dispatch("init");
			    }).catch(() => {
				    this.isLoading = false;
				    this.$refs.captcha && this.$refs.captcha.clear();
			    });
		    }
	    }
    },
	  computed: {
		  ...mapGetters(['account'])
	  }
  };
</script>
